import { createContext, useContext, useEffect, useState, useCallback } from "react";

const LanguageContext = createContext({ lang: "en", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "en";
        return localStorage.getItem("rvs-lang") || "en";
    });

    useEffect(() => {
        document.documentElement.lang = lang;
        localStorage.setItem("rvs-lang", lang);
    }, [lang]);

    const setLang = (l) => setLangState(l);

    return (
        <LanguageContext.Provider value={{ lang, setLang }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);

export const useT = () => {
    const { lang } = useContext(LanguageContext);
    return useCallback((en, te) => (lang === "te" ? (te ?? en) : en), [lang]);
};
